import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1d0fbf",
    },
    text: {
      primary: "#1e2834",
    },
    secondary: {
      main: "#fad618",
    },
    background: {
      default: "#F4F7F9",
    },
  },
});

export default theme;
